// eslint-disable-next-line import/prefer-default-export
export const dispatchConductricsEvent = () => {
  window.dispatchEvent(
    new CustomEvent("ConductricsStateChange", { detail: "vs-VeqsqJUkLm" })
  );
};
